import { z } from "zod";

export const ibanRegex = /^[A-Z0-9]{15,34}$/;
export const bicRegex = /^[A-Z]{6}[A-Z2-9][A-NP-Z0-9]([A-Z0-9]{3})?$/;
const defaultError = "Veuillez entrer un nom";

export const addBankDetailsSchema = z.object({
  accountName: z.string().min(1, defaultError),
  ownerName: z.string().min(1, defaultError),
  bankName: z.string().min(1, defaultError),
  iban: z
    .string()
    .min(1, "Veuillez entrer un IBAN")
    .refine((iban) => {
      const clearedIban = iban.replace(/ /g, "").toUpperCase();

      return clearedIban.match(ibanRegex);
    }, "Veuillez entrer un IBAN valide"),
  bic: z
    .string()
    .min(1, "Veuillez entrer un BIC")
    .refine((bic) => {
      const clearedBic = bic.replace(/ /g, "").toUpperCase();

      return clearedBic.match(bicRegex);
    }, "Veuillez entrer un BIC valide"),
  country: z.string().min(1),
  zipCode: z.string().min(1),
  city: z.string().min(1),
  address: z.string().min(1),
});

export const defaultAddBankDetailsValues = {
  accountName: "",
  ownerName: "",
  bankName: "",
  iban: "",
  bic: "",
  country: "",
  zipCode: "",
  city: "",
  address: "",
};

export type AddBankDetailsForm = z.infer<typeof addBankDetailsSchema>;
